export const DATE_ISO = "YYYY-MM-DD";
export const MS_PER_DAY = 24 * 60 * 60 * 1000;
